import router from '../routers/router'
import axios from 'axios';

const UserAuthentication = {
  install(Vue) {
    if (!Vue.prototype.currentUser) {
      Vue.prototype.currentUser = null
    }

    Vue.prototype.$currentUser = function () {
      if (this.currentUser && this.currentUser.token) return this.currentUser

      var json = localStorage.currentUser
      if (!json) return {}

      this.$store.dispatch('getCurrentAnosafra')
      this.currentUser = JSON.parse(json)
      this.$store.dispatch('getNotificationsCounter')

      return this.currentUser
    }

    Vue.prototype.$updateUser = function (user) {
      this.currentUser = user
      localStorage.currentUser = JSON.stringify(user)
    }

    Vue.prototype.$unauthenticateUser = async function () {
      try {
        await this.$http.plain.delete("/api/v1/logout")
        
        localStorage.removeItem('userToken');
        localStorage.removeItem('currentUser');

        if (router.currentRoute && router.currentRoute.path !== '/login') {
          router.replace('/login');
        }

      } catch (error) {
        console.error('Erro ao fazer logout:', error);
      }
    };

    Vue.prototype.$authenticateUser = async function () {
      try {
        const response = await this.$http.plain.post('/api/v1/login', {})
        this.$updateUser(response.data)
      } catch (error) {
        console.warn("[userAuthentication][$authenticateUser] Unable to authenticate user ", error)
        this.$unauthenticateUser()
      }
    }

    Vue.prototype.$can = function (action, controller) {
      if (!(this.$currentUser().all_permissions && this.$currentUser().all_permissions.length > 0 )) {
        return false
      }

      return !!this.$currentUser().all_permissions.find(permission =>
        (action == 'any' || 'manage' == permission.action_name || action == permission.action_name) && (controller == 'any' || controller == permission.subject_class));
    }
  }
};

export default UserAuthentication;
